import { Component, OnDestroy, Input, forwardRef, OnChanges, EventEmitter, Output, OnInit } from "@angular/core";

import { IdService } from "../shared/services/id.service";
import { FormControlBase } from "../shared/classes/form-control-base";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
	selector: "rbc-button-toggle",
	template: `
		<fieldset [id]="id" [ngClass]="classGen()" class="rbc-button-toggle">
			<slot select="[header]">
				<legend
				[ngClass]="{ 'sr-only': labelSrOnly }"
				class="rbc-label">
				{{ label }}
				</legend>
			</slot>
			<rbc-button-toggle-inner
				#control
				*ngFor="let opt of options; let key = index"
				[id]="id"
				[(ngModel)]="innerValue"
				[selected]="innerValue"
				[label]="opt.label"
				[name]="name"
				[disabled]="disabled || opt.disabled || disabledState"
				[value]="opt.value"
				(ngModelChange)="toggleHandler($event)"
				ngDefaultControl
			>
			</rbc-button-toggle-inner>
		</fieldset>
	`,
	styles: [],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => ButtonToggleComponent)
		}
	]
})
export class ButtonToggleComponent extends FormControlBase<string>
	implements OnDestroy, OnInit {
	@Input() color: "primary" | "secondary" | "dark" | "light" = "primary";
	@Input() id: string;
	@Input() size: "large" | "medium" | "small" = "large";
	@Input() wrapChildren: boolean;
	@Input() label: string;
	@Input() labelSrOnly = true;
	@Input() options: [];
	@Input() name: string;
	@Input() disabled: boolean;
	@Input() fullWidth: boolean;

	constructor(private idService: IdService) {
		super();
		this.id = idService.generate();
	}

	ngOnInit(){
	}

	classGen() {
		const classes = {};

		classes[`rbc-button-toggle-${this.size}`] = this.size;
		classes[`rbc-button-toggle-${this.color}`] = this.color;
		classes["rbc-button-toggle-block"] = this.fullWidth;
		classes["rbc-button-toggle-wrap-children"] = this.wrapChildren;

		return classes;
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
		super.ngOnDestroy();
	}

	toggleHandler(value: string) {
		this.innerValue = value;
		this.changed(value);
	}


}
